import { create } from 'zustand';
import { PermissionsUtils } from '@shared/utils';
import { ApiUtils, MessagesApi, type MessageThreadEntity, RequestStrategyEnum } from '@shared/api';

interface UseThreadsStore {
  loading: boolean;
  data: MessageThreadEntity[];
  error: string | null;
  getThreads: (signal?: AbortSignal) => Promise<void>;
  deleteThread: (threadId: string, signal?: AbortSignal) => Promise<void>;
  markAsRead: (threadId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useThreadsStore = create<UseThreadsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getThreads: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await MessagesApi.getThreads(signal);
      const userId = PermissionsUtils.getUserId();
      const threads = result.data.map((item) => ({ ...item, replyReceiverId: userId === item.receiverId ? item.userId : item.receiverId }));
      set({ loading: false, data: threads });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Default),

  deleteThread: async (threadId, signal) => {
    try {
      set({ loading: true, error: null });
      await MessagesApi.deleteMessageGroup(threadId, signal);
      useThreadsStore.getState().getThreads();
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  markAsRead: ApiUtils.wrapperApi(async (threadId, signal) => {
    try {
      set({ loading: true, error: null });
      await MessagesApi.markGroupRead(threadId, signal);
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
